import { render, staticRenderFns } from "./edit-index-vuetify.vue?vue&type=template&id=74af1255"
import script from "./edit-index-vuetify.vue?vue&type=script&lang=js"
export * from "./edit-index-vuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports